import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.imputaciones.titulosSeparaciones.create}
                buttonTitle={"Nuevo Título"}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"El parámetro ha sido creado con éxito."}
                title={"Nuevo Título"}
                buttonIcon={"fa fa-plus fa-lg"}
                className={"ui-modal-dialog"}
                saveButton={true}
                closeButton={true}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Datos del parámetro</h5>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Nombre</label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/TitulosSeparaciones/Create.js